import { useState } from 'react';
import { LatePaymentPenalty } from '../models/contractModel';
import { Button, Form, FormGroup, Label, Input, Table } from 'reactstrap';

interface Props {
  penalties: LatePaymentPenalty[];
  handleConfirmation: (penalties: LatePaymentPenalty[]) => void;
}

const ContractPenaltiesForm = ({
  penalties: initialPenalties,
  handleConfirmation,
}: Props) => {
  const [penalties, setPenalties] =
    useState<LatePaymentPenalty[]>(initialPenalties);

  const handleInputChange = (
    index: number,
    event: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const { name, value, type, checked } = event.target;
    const newPenalties = [...penalties];

    if (type === 'checkbox') {
      newPenalties[index] = { ...newPenalties[index], [name]: checked };
    } else {
      newPenalties[index] = { ...newPenalties[index], [name]: value };
    }

    setPenalties(newPenalties);
  };

  const handleSubmit = (event: React.FormEvent) => {
    event.preventDefault();
    handleConfirmation(penalties);
  };
  return (
    <Form onSubmit={handleSubmit}>
      <Table bordered>
        <thead>
          <tr>
            <th>Estado</th>
            <th>Desde</th>
            <th>Hasta</th>
            <th>Porcentaje de penalidad</th>
          </tr>
        </thead>
        <tbody>
          {penalties.map((penalty, index) => (
            <tr key={index}>
              <td className="text-center">
                <FormGroup>
                  <Input
                    type="checkbox"
                    name="is_active"
                    checked={penalty.is_active}
                    onChange={(e) => handleInputChange(index, e)}
                  />
                </FormGroup>
              </td>
              <td className="text-center">
                <FormGroup>
                  <Input
                    type="number"
                    name="from_day_of_month"
                    value={penalty.from_day_of_month}
                    onChange={(e) => handleInputChange(index, e)}
                  />
                </FormGroup>
              </td>
              <td className="text-center">
                <FormGroup>
                  <Input
                    type="number"
                    name="to_day_of_month"
                    value={penalty.to_day_of_month}
                    onChange={(e) => handleInputChange(index, e)}
                  />
                </FormGroup>
              </td>
              <td className="text-center">
                <FormGroup>
                  <Input
                    type="number"
                    name="percentage_penalty"
                    value={penalty.percentage_penalty}
                    onChange={(e) => handleInputChange(index, e)}
                  />
                </FormGroup>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
      <Button color="primary" type="submit">
        Guardar penalidades
      </Button>
    </Form>
  );
};

export default ContractPenaltiesForm;
